import React, { useEffect, useState } from "react";
import "./ScrollDownArrow.scss";

function ScrollDownArrow() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Hide the arrow after scrolling down a bit (e.g., 300px)
      if (window.scrollY > 300) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`scroll-down-arrow ${isVisible ? "visible" : "hidden"}`}>
      <i className="fa-solid fa-chevron-down"></i>
    </div>
  );
}

export default ScrollDownArrow;

